<div class="form-group materialize {{behaviourClasses}}">
	<kendo-dropdownlist class="form-control" [id]="controlId" [data]="data" [textField]="textField" [valueField]="valueField"
	 [popupSettings]="popupSettings" [filterable]="filterable" [valuePrimitive]="valuePrimitive" [disabled]="disabled" [(ngModel)]="value"
	 [ngModelOptions]="ngModelOptions" [listHeight]="listHeight" (focus)="_handleFocus($event)" (blur)="_handleBlur($event)" (valueChange)="_handleChange($event)"
	 (selectionChange)="selectionChange.emit($event)">
	</kendo-dropdownlist>
	<label [for]="controlId">{{label}}</label>
	<validation-messages *ngIf="showFailures" [messages]="failures"></validation-messages>
</div>